import React from "react";
import '../../sass/components/flexibleModules/_components.iconsGridAndFourColumnSection.scss';

const IconsGridAndFourColumnSection = ({ data }) => {
    return (
        <div className={`cp-iconsGridAndFourColumnSection l-${data.iconsGridAndFourColumnSectionLayoutSelection} ${data.overrideClass ? data.overrideClass : "l-noOverride"}`}>
            <div className="cp-iconsGridAndFourColumnSection__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.iconsGridHeader &&
                    <h2 data-sal="slide-right" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease">{data.iconsGridHeader}</h2>
                }
                {data.iconsGridSections &&
                    <div className={`cp-iconsGridAndFourColumnSection__grid l--flex ${data.iconsGridAndFourColumnSectionLayoutSelection} l-columnCheck${data.iconsGridAndFourColumnSectionColumnSelection}`}>
                        {data.iconsGridSections.map((grid, index) => (
                            <div data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease" className="cp-iconsGridAndFourColumnSection__grid-section" key={index}>
                                {grid.iconsGridSectionIcon &&
                                    <img data-sal="flip-left" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease" style={{maxWidth: `${grid.iconsGridSectionIconMaxWidth ? grid.iconsGridSectionIconMaxWidth : ""}px`}} src={grid.iconsGridSectionIcon.sourceUrl} alt={grid.iconsGridSectionIcon.altText} loading="lazy" />
                                }
                                {grid.iconsGridSectionHeader &&
                                    <h3>{grid.iconsGridSectionHeader}</h3>
                                }
                                {grid.iconsGridSectionTeaser &&
                                    <div dangerouslySetInnerHTML={{__html: grid.iconsGridSectionTeaser}} />
                                }
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
}

export default IconsGridAndFourColumnSection;